import { dataAxureFetch } from "./fetch";

/**
 * Change String in Array
 * @param {string} format -String the color
 * @returns -Array
 */
const colorArr = (format)=> format.split(';')

/**
 * To get colors
 * @param {number} uid -Id client
 * @param {string} colorPetition -To Select Color
 * @returns Array with String
 */
export const getColors = async(uid,colorPetition ) =>{
    const responseTotalPoints = await dataAxureFetch(
        {
            solicitud:"colores",
            idCliente:uid
        }
        ,'POST'
    );
    const color=responseTotalPoints[0]
    
    
    if(colorPetition==='puntosgis'){
        return colorArr(color.puntosgis)
    }else if(colorPetition==='rayoslinet'){
        return colorArr(color.rayoslinet)
    }else if(colorPetition==='rayosglm'){
        return colorArr(color.rayosglm)
    }else if(colorPetition==='rayoshist'){
        return colorArr(color.rayoshist)
    }
}